export enum FeatureFlag {
  favoriteTokens = 'favoriteTokens',
  nft = 'nfts',
  traceJsonRpc = 'traceJsonRpc',
  multiNetworkBalances = 'multiNetworkBalances',
  nftGraphQl = 'nftGraphQl',
}
